export default __webpack_public_path__ + "static/media/women.5a2a7504.JPG";